'use client';
import type { ReactElement } from 'react';
import { BAR_RADIUS } from './gantt-constants';
import type { GanttBarSegmentModel } from './gantt-bar-selectors';
export interface GanttBarSegmentProps {
    segment: GanttBarSegmentModel;
}
export function GanttBarSegment({ segment, }: GanttBarSegmentProps): ReactElement {
    return (
      <rect x={segment.x} y={segment.y} width={segment.width} height={segment.height} rx={BAR_RADIUS} fill={segment.fill} opacity={segment.opacity}/>
    );
}
